/* eslint-disable no-nested-ternary */
// TODO: refactor this module to meet 'no-nested-ternary' rule
import _ from 'lodash';
import React, { Component } from 'react';
import momentTimezone from 'moment-timezone';
import update from 'immutability-helper';
import Select from '../shared/Select';
import WoundPhotoDiary from './WoundPhotoDiary';
import WoundRecommendation from './WoundRecommendation';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
} from '../../constants/RoleConstants';
import { PAININDEX } from '../../constants/PainIndexImage';
import { PatientAPIConnectors } from '../../api';
import i18n from '../../config/i18n';

const styles = {
  wrapper: {
    overflowX: 'auto',
  },
  table: {
    marginBottom: 0,
  },
  thead: {
    backgroundColor: '#FFFAF1',
    color: '#2D3E4F',
  },
  th: {
    fontSize: 18,
    paddingBottom: 12,
  },
  timelabel: {
    textAlign: 'center',
    paddingTop: 17,
  },
  edit: {
    textAlign: 'right',
  },
  image: {
    maxWidth: 350,
    margin: 'auto',
  },
};

class WoundAssessment extends Component {
  constructor(props) {
    super(props);
    const { info } = this.props;
    this.state = {
      showExtra: false,
      assesmentStats: { // TODO: fix this typo in another ticket
        bleeding: info.bleeding || '',
        exudate: info.exudate || '',
        fistula: info.fistula || '',
        oozing: info.oozing || '',
        tissueExposure: info.tissueExposure || '',
        periUlcerative: info.periUlcerative || '',
        rash: info.rash || '',
        painIndex: info.painIndex || 0,
      },
      isEditing: false,
      isUpdating: false,
    };

    this.cancel = this.cancel.bind(this);
    this.edit = this.edit.bind(this);
    this.expand = this.expand.bind(this);
    this.update = this.update.bind(this);
    this.handleBleedingChange = this.handleBleedingChange.bind(this);
    this.handleExudateChange = this.handleExudateChange.bind(this);
    this.handleFistulaChange = this.handleFistulaChange.bind(this);
    this.handleOozingChange = this.handleOozingChange.bind(this);
    this.handlePainIndexChange = this.handlePainIndexChange.bind(this);
    this.handlePeriUlcerativeChange = this.handlePeriUlcerativeChange.bind(this);
    this.handleRashChange = this.handleRashChange.bind(this);
    this.handleTissueExposureChange = this.handleTissueExposureChange.bind(this);
  }

  setInputsToDefaultValues() {
    const { info } = this.props;
    this.setState({
      assesmentStats: {
        bleeding: info.bleeding || '',
        exudate: info.exudate || '',
        fistula: info.fistula || '',
        oozing: info.oozing || '',
        tissueExposure: info.tissueExposure || '',
        periUlcerative: info.periUlcerative || '',
        rash: info.rash || '',
        painIndex: info.painIndex || 0,
      },
    });
  }

  expand() {
    const {
      isEditing,
      showExtra,
    } = this.state;
    if (isEditing) {
      this.setState({
        showExtra: !showExtra,
        isEditing: false,
      });
    }
    this.setState({ showExtra: !showExtra });
  }

  edit() {
    this.setState({ isEditing: !this.state.isEditing });
  }

  cancel() {
    this.setState({ isEditing: false });
    this.setInputsToDefaultValues();
  }

  update() {
    const {
      id,
      actions: {
        createSuccessAlert,
        createAlert,
      },
    } = this.props;
    const statistics = { info: { ...this.state.assesmentStats } };
    PatientAPIConnectors.updateAssessment(statistics, id)
      .then(() => {
        createSuccessAlert(i18n.t('updateAssessmentStatisticsSucceedMsg'));
        this.setState({ isEditing: !this.state.isEditing });
      })
      .catch((err) => {
        createAlert(err.message);
        this.setInputsToDefaultValues();
      });
  }

  handleBleedingChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { bleeding: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handleExudateChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { exudate: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handleFistulaChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { fistula: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handleOozingChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { oozing: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handleTissueExposureChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { tissueExposure: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handlePeriUlcerativeChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { periUlcerative: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handleRashChange(value) {
    const newAssesmentStats = update(this.state.assesmentStats,
      { rash: { $set: value } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  handlePainIndexChange(e) {
    let validValue = parseInt(e.target.value, 10);
    if (e.target.value === '' || isNaN(validValue)) {
      validValue = '';
    } else if (validValue < 0) {
      validValue = 0;
    } else if (validValue > 10) {
      validValue = 10;
    }

    const newAssesmentStats = update(this.state.assesmentStats,
      { painIndex: { $set: validValue } });
    this.setState({ assesmentStats: newAssesmentStats });
  }

  uploadWoundPhoto() {
    const {
      woundId,
      id,
    } = this.props;
    const { href } = window.location;

    window.location.href = `${href}/wounds/${woundId}/assessment/${id}/photo-upload`;
  }

  canEditAssessment() {
    const { user: { profile: { roleId } } } = this.props;
    return [DOCTOR_ID, ASSISTANT_ID, NURSE_ID].indexOf(roleId) > -1;
  }

  render() {
    const {
      metadata,
      depth,
      width,
      height,
      photos,
      woundId,
      user,
      id,
      recommendations,
      created,
      actions,
    } = this.props;
    const {
      assesmentStats,
      isEditing,
      showExtra,
      isUpdating,
    } = this.state;
    const {
      wrapper,
      table,
      image,
      thead,
      th,
      timelabel,
      edit,
    } = styles;
    const exudate = _.filter(metadata.data.exudate, { id: parseInt(assesmentStats.exudate, 10) });
    const tissueExposure = _.filter(metadata.data.tissueExposure,
      { id: parseInt(assesmentStats.tissueExposure, 10) });
    const periUlcerative = _.filter(metadata.data.periUlcerative,
      { id: parseInt(assesmentStats.periUlcerative, 10) });
    const yesOrNo = [
      { id: 0, name: i18n.t('yes') },
      { id: 1, name: i18n.t('no') },
    ];
    const woundAssessmentTable = showExtra && (
      <table className="table table-bordered table-responsive patient" style={table}>
        <tbody>
          <tr>
            <th width="25%">
              {i18n.t('woundSize')}
            </th>
            <td width="25%">
              <span>{`${i18n.t('depth_cm')}: ${depth}`}</span> <br />
              <span>{`${i18n.t('width_cm')}: ${width}`}</span> <br />
              <span>{`${i18n.t('length_cm')}: ${height}`}</span>
            </td>
            <th width="25%">
              {i18n.t('bleeding')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={yesOrNo}
                    onChange={this.handleBleedingChange}
                    value={assesmentStats.bleeding}
                  />
                ) : (
                  i18n.t(assesmentStats.bleeding === '0' ? 'yes' : 'no')
                )
              }
            </td>
          </tr>
          <tr>
            <th width="25%">
              {i18n.t('exudate')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={metadata.data.exudate || []}
                    onChange={this.handleExudateChange}
                    value={assesmentStats.exudate}
                  />
                ) : (
                  exudate[0] ? exudate[0].name : ''
                )
              }
            </td>
            <th width="25%">
              {i18n.t('fistula')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={yesOrNo}
                    onChange={this.handleFistulaChange}
                    value={assesmentStats.fistula}
                  />
                ) : (
                  i18n.t(assesmentStats.fistula === '0' ? 'yes' : 'no')
                )
              }
            </td>
          </tr>
          <tr>
            <th width="25%">
              {i18n.t('oozing')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={yesOrNo}
                    onChange={this.handleOozingChange}
                    value={assesmentStats.oozing}
                  />
                ) : (
                  i18n.t(assesmentStats.oozing === '0' ? 'yes' : 'no')
                )
              }
            </td>
            <th>
              {i18n.t('painIndex')}
            </th>
            <td>
              {
                isEditing ? (
                  <input
                    type="text"
                    className="form-control input-sm"
                    placeholder={i18n.t('painIndex_0_10')}
                    value={assesmentStats.painIndex}
                    onChange={this.handlePainIndexChange}
                  />
                ) : (
                  assesmentStats.painIndex
                )
              }
            </td>
          </tr>
          <tr>
            <th width="25%">
              {i18n.t('periUlcerative')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={metadata.data.periUlcerative || []}
                    onChange={this.handlePeriUlcerativeChange}
                    value={assesmentStats.periUlcerative}
                  />
                ) : (
                  periUlcerative[0] ? periUlcerative[0].name : ''
                )
              }
            </td>
            <td colSpan="4" rowSpan="3">
              <img
                src={PAININDEX.PainIndex}
                style={image}
                className="img-responsive"
                alt={i18n.t('painIndex')}
              />
            </td>
          </tr>
          <tr>
            <th width="25%">
              {i18n.t('rash')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={yesOrNo}
                    onChange={this.handleRashChange}
                    value={assesmentStats.rash}
                  />
                ) : (
                  i18n.t(assesmentStats.rash === '0' ? 'yes' : 'no')
                )
              }
            </td>
          </tr>
          <tr>
            <th width="25%">
              {i18n.t('tissueExposure')}
            </th>
            <td width="25%">
              {
                isEditing ? (
                  <Select
                    className="form-control input-sm"
                    data={metadata.data.tissueExposure || []}
                    onChange={this.handleTissueExposureChange}
                    value={assesmentStats.tissueExposure}
                  />
                ) : (
                  tissueExposure[0] ? tissueExposure[0].name : ''
                )
              }
            </td>
          </tr>
        </tbody>
      </table>
    );
    const woundPhotosDiary = showExtra && (
      <WoundPhotoDiary
        photos={photos}
        woundId={woundId}
        id={id}
        {...this.props}
      />
    );
    const doctorRecommendations = showExtra && (
      <WoundRecommendation
        {...recommendations[0]}
        assessmentId={id}
        actions={actions}
        metadata={metadata}
        user={user}
      />
    );

    return (
      <div style={wrapper}>
        <table className="table table-bordered table-responsive patient" style={table}>
          <thead style={thead}>
            <tr>
              <th width="25%" style={th}>
                {i18n.t('woundAssessment')}
              </th>
              <td style={timelabel}>
                {i18n.t('assessmentDate_pst', {
                  assessmentDate: momentTimezone(created).tz('America/Los_Angeles').format('YYYY-MM-DD, hh:mm:ss a'),
                })}
              </td>
              <td width="25%" style={edit}>
                <div className="btn-group">
                  {
                    this.canEditAssessment() ? (
                      isEditing ? (
                        <div>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={this.update}
                            disabled={!showExtra}
                          >
                            {i18n.t('update')}
                          </button>
                          <button
                            className="btn btn-sm btn-default"
                            onClick={this.cancel}
                            disabled={isUpdating}
                          >
                            {i18n.t('cancel')}
                          </button>
                          <button className="btn btn-sm btn-primary" onClick={this.expand}>
                            {i18n.t(showExtra ? 'collapse' : 'expand')}
                          </button>
                        </div>
                      ) : (
                        <div>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={this.edit}
                            disabled={!showExtra}
                          >
                            {i18n.t('edit')}
                          </button>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={this.expand}
                          >
                            {i18n.t(showExtra ? 'collapse' : 'expand')}
                          </button>
                        </div>
                      )
                    ) : (
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={this.expand}
                      >
                        {i18n.t(showExtra ? 'collapse' : 'expand')}
                      </button>
                    )
                  }
                </div>
              </td>
            </tr>
          </thead>
        </table>
        {woundAssessmentTable}
        {woundPhotosDiary}
        {doctorRecommendations}
      </div>
    );
  }
}

export default WoundAssessment;



// WEBPACK FOOTER //
// ./src/components/patient/WoundAssessment.js